/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { ComponentType } from 'react';
import { CORE_PROJECT } from '@jira/platform__project-types/src/project-types.tsx';
import { projectLayout } from '@jira/platform__layouts-project-layout/src/index.tsx';
import {
	composeLayouts,
	withProjectContext,
	type Layout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { componentWithFG } from '@jira/platform__utils-feature-gates-gate-component';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const Onboarding = lazyAfterPaint(
	() =>
		import(/* webpackChunkName: "async-business-project-onboarding" */ './ui/onboarding/index.tsx'),
	{ ssr: false },
);

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const withAnyBusinessProjectContext = (Component: ComponentType<Record<any, any>>) =>
	withProjectContext(Component, {
		project: {
			style: 'any',
			type: CORE_PROJECT,
		},
	});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const RightSidebars = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-business-project-right-sidebars" */ './ui/right-sidebars/index.tsx'
		),
	{ ssr: false },
);

const BusinessOnboarding = componentWithFG(
	'jira-fix-quickstart-not-showing',
	Onboarding,
	withAnyBusinessProjectContext(Onboarding),
);
BusinessOnboarding.displayName = 'BusinessOnboarding';

const nonSettingsRightSidebar = componentWithFG(
	'jira-fix-quickstart-not-showing',
	RightSidebars,
	withAnyBusinessProjectContext(RightSidebars),
);
nonSettingsRightSidebar.displayName = 'NonSettingsRightSidebar';

const sharedBusinessProjectLayout: Layout = composeLayouts(projectLayout);

export const businessProjectLayout: Layout = composeLayouts(sharedBusinessProjectLayout, {
	rightSidebars: [nonSettingsRightSidebar],
	globalComponents: [BusinessOnboarding],
});
